export default __webpack_public_path__ + "static/media/we-mark.1b08af95.png";